import React from "react";
import Routes from "./components/routes/Routes";
import styles from "./App.module.css";

function App() {
  return (
    <div className={styles.content}>
      <Routes />
    </div>
  );
}

export default App;
